// Desktop menu
$(function() {
    $('.nav--primary .dropdown').each(function() {
        const dropdown = $(this).find('.dropdown__menu');
        dropdown.addClass($(this).data('sub'));
        $('.sub-menu__content').prepend(dropdown);
    });

    const closeSubmenu = function (slideUp = true) {
        // Alle huidige menu items niet active meer maken
        $('.nav-item.dropdown').removeClass('active-sub-menu').find('.fas').removeClass('fa-minus').addClass('fa-plus');

        // Huidig opengeklapte submenu hiden
        $('.sub-menu .dropdown__menu').hide();

        if (slideUp){
            // Sub menu container hiden
            $('.sub-menu').slideUp();
        }
    };

    $('.nav--primary .nav-item:not(.dropdown)').on('mouseenter', function() {
        if (window.innerWidth < 992) {
            return;
        }

        closeSubmenu();
    });

    $('.header').on('mouseleave', function() {
        if (window.innerWidth < 992) {
            return;
        }

        closeSubmenu();
    });

    $('.dropdown').on('mouseenter', function() {
        if (window.innerWidth < 992) {
            return;
        }

        if($(this).hasClass('active-sub-menu')) {
            return;
        }

        closeSubmenu(false);

        // Huidige menu item active maken
        $(this).addClass('active-sub-menu').find('.fas').removeClass('fa-plus').addClass('fa-minus');

        // Huidige submenu openen
        $('.sub-menu .' + $(this).data('sub')).fadeIn('fast').css('display', 'flex');

        // Sub menu container showen
        $('.sub-menu').slideDown();
    });
});

// Mobile menu
$(function () {
    $('.nav--mobile .dropdown__menu-toggler').on('click', function () {
        if (window.innerWidth >= 992) {
            return;
        }

        // Alle andere submenu's hiden
        $('.nav--mobile .dropdown__menu').not($(this).next()).slideUp().removeClass('active-sub-menu');
        $('.nav--mobile .dropdown__menu-toggler').not($(this)).removeClass('active-sub-menu').find('.fas').removeClass('fa-minus').addClass('fa-plus');

        // Huidige submenu showen
        $(this).toggleClass('active-sub-menu').find('.fas').toggleClass('fa-minus fa-plus');
        $(this).next().toggleClass('active-sub-menu').slideToggle();
    });
});
